import { Box, Button, FormControlLabel, FormGroup, Grid, Switch, Typography } from "@mui/material";
import React, { useState } from "react";
import HelmetReact from "../../Components/Helmet";
import Resetpassword from "./resetPassword";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getMaintenanceModeStatus, maintenanceModeStatus } from "../../Redux/Actions/userAction";
import { useErrorHandler } from "../../hooks";
import { useEffect } from "react";
import ResponsiveDialog from "../../Components/DialogBox";

const Settings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { maintenanceStatus, loading } = useSelector((state) => state.User)
  const { setMsgConfig } = useErrorHandler();
  const [open, setOpen] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  useEffect(() => {
    dispatch(getMaintenanceModeStatus())
  }, [maintenanceMode])

  useEffect(() => {    
    if (loading === false && maintenanceStatus) {
      setMaintenanceMode(maintenanceStatus.is_under_maintenance)
    }
  }, [])

  const handleChange = (e) => {
    if(e.target.checked === true){
      setIsVisibleModal(true);
    }
    else{
      setMaintenanceMode(e.target.checked)
    let payload = {}
    payload = {
      id: maintenanceStatus.id,
      is_under_maintenance: e.target.checked
    }
    dispatch(maintenanceModeStatus(payload))
    setMsgConfig({
      alertOpen: true,
      message: "Maintenance Mode On successfully!",
      severity: "success",
      autoHideDuration: 2000,
    });
    dispatch(getMaintenanceModeStatus())
    }    
  };

  const handleAllow = () => {
    let payload = {}
    payload = {
      id: maintenanceStatus.id,
      is_under_maintenance: true
    }
    dispatch(maintenanceModeStatus(payload))
    setMsgConfig({
      alertOpen: true,
      message: "Maintenance Mode On successfully!",
      severity: "success",
      autoHideDuration: 2000,
    });
    dispatch(getMaintenanceModeStatus())
    setMaintenanceMode(true);
    setIsVisibleModal(false);    
  };
  return (
    <>
    <ResponsiveDialog
        dtype={"permission"}
        open={isVisibleModal}
        header={ "Are you sure you want to take mobile app under maintenance ?"}
        onConfirm={() =>
          handleAllow()
        }
        onClose={() => {          
          setIsVisibleModal(false);
        }}
      ></ResponsiveDialog>
      <HelmetReact name="Setting" />
      <Box className="d-details-box">
        <Typography className="web-title">SETTINGS</Typography>
        <Grid row-gap={4}>
          <Button onClick={() => navigate("/settings/userPermission")}>
            USERS PERMISSIONS
          </Button>
        </Grid>
        <Grid row-gap={4}>
          <Button>SECURITY SETTINGS</Button>
        </Grid>
        <Grid row-gap={4}>
          <Button onClick={handleClick}>Reset Password</Button>
        </Grid>
        <Grid row-gap={4}>
          <FormGroup sx={{ width: "10px" }}>
            <FormControlLabel control={<Switch checked={maintenanceMode} onChange={handleChange} />} label="Maintenance" />
          </FormGroup>
        </Grid>
      </Box>
      {open && <Resetpassword open={open} setOpen={setOpen} />}
    </>
  );
};

export default Settings;
